import React from "react";

/**
 * Creates a RequiredSymbol component.
 *
 * @return {JSX.Element} The RequiredSymbol component
 */
export const RequiredSymbol = () => {
  return (
    <span className="inline-block !h-full leading-[normal] text-red">*</span>
  );
};
